import React from 'react';
import './WHMCS.css';

const WHMCSModules = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <>
      <div className="seo-header">
        <h1>ماژول WHMCS | توسعه و نصب ماژول‌های اختصاصی | افراسل</h1>
        <p>توسعه و نصب ماژول‌های اختصاصی WHMCS برای اتصال به cPanel، DirectAdmin، Plesk و سایر سیستم‌ها.</p>
        <meta name="description" content="توسعه و نصب ماژول‌های اختصاصی WHMCS برای هاستینگ، دامنه و سرور." />
      </div>

      <section className="whmcs-hero">
        <div className="whmcs-hero-bg"></div>
        <div className="wrap">
          <div className="whmcs-hero-content">
            <div className="whmcs-badge">
              <span className="pulse-dot"></span>
              🧩 ماژول WHMCS
            </div>
            <h1 className="whmcs-hero-title">
              ماژول <em>WHMCS</em>
            </h1>
            <p className="whmcs-hero-desc">
              ماژول‌های WHMCS امکان اتصال به سیستم‌های مختلف را فراهم می‌کنند. ماژول‌های هاستینگ (cPanel، DirectAdmin، Plesk)، دامنه (Enom، ResellerClub)، سرور (Virtualizor، SolusVM) و درگاه‌های پرداخت. همچنین ماژول‌های اختصاصی بر اساس نیاز شما توسعه داده می‌شوند.
            </p>
            <div className="whmcs-hero-stats">
              <div className="stat-item">
                <span className="stat-number">اختصاصی</span>
                <span className="stat-label">توسعه سفارشی</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">۱۰۰+</span>
                <span className="stat-label">پروژه موفق</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">۲۴/۷</span>
                <span className="stat-label">پشتیبانی</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="whmcs-cta">
        <div className="wrap">
          <div className="cta-box">
            <h2 className="cta-title">
              ماژول <em>WHMCS</em> را با افراسل تجربه کنید
            </h2>
            <p className="cta-desc">
              با ماژول‌های اختصاصی WHMCS، سیستم خود را به هر سرویسی متصل کنید.
            </p>
            <div className="cta-btns">
              <button className="btn-lg primary" onClick={() => scrollTo('contact')}>مشاوره رایگان</button>
              <button className="btn-lg ghost" onClick={() => scrollTo('contact')}>درخواست خدمات</button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default WHMCSModules;
